import * as ng from '@angular/core';
import {Component} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import * as Rx from 'rxjs'
import {Mag2LocalStorage, PlayerMode} from "../../../lib/mag2-local-storage";
import {AngularFirestore} from "@angular/fire/firestore";
import {environment} from "../../../env/environment";
import {Live, Follow} from "../../../lib/entity/live";
import {PlayerNative} from "../../../lib/player/player-native";
import {playbackQuery, playbackURLOf} from "../../../lib/castify-helper";
import {MagliveApiClient} from "../../../lib/api-client/maglive-api-client";
import {LiveUserAuthority} from "../../../lib/entity/live-user-authority";
import {DebugUser} from "../../../env/config";
import {map} from "rxjs/operators";

@Component({
  templateUrl: './debug-page.component.html',
  styleUrls: ['./debug-page.component.scss']
})
export class DebugPageComponent implements ng.OnInit, ng.OnDestroy {

  @ng.Input()
  userId: number | null;
  @ng.Input()
  userNickname: string;

  authority: LiveUserAuthority | undefined

  userIconURL: string;
  @ng.ViewChild("userIconInput", {static: true})
  userIconInput: ng.ElementRef<HTMLInputElement>;

  changedUserId: boolean = false;
  playerModes: PlayerMode[] = ["AUTO", "NATIVE", "HLS.JS"];
  selectedPlayerMode: PlayerMode = Mag2LocalStorage.getPlayerMode();
  changedPlayerMode: boolean = false;

  @ng.ViewChild("video", {static: true})
  video: ng.ElementRef<HTMLVideoElement>;
  player: PlayerNative;

  @ng.Input()
  liveThumbnailMagazineId: string;
  liveThumbnails: {URL: string, path: string}[] = [];
  @ng.ViewChild("liveThumbnailInput", {static: true})
  liveThumbnailInput: ng.ElementRef<HTMLInputElement>;

  @ng.Input()
  followMagazineId: string;
  follows: Rx.Observable<Follow[]>;

  debugUsers: DebugUser[] = environment.debugUsers;

  constructor(
    private afs: AngularFirestore,
    private http: HttpClient
  ) {
  }

  ngOnInit(): void {
    const userId = Mag2LocalStorage.getUserId();
    if (userId !== null) {
      this.userId = userId;
      this.reload();
    }
  }

  login(userId: number | null) {
    this.userId = userId;

    if (userId === null) {
      Mag2LocalStorage.removeUserId();
    } else {
      Mag2LocalStorage.setUserId(userId);
    }

    this.changedUserId = true;
    this.reload();

    let x = Rx.interval(1000).subscribe(() => {
      this.changedUserId = false;
      x.unsubscribe();
    });
  }

  submitNickname() {
    MagliveApiClient.editMyProfile(this.userNickname).subscribe(console.log);
  }

  removeNickname() {
    MagliveApiClient.removeUserProfile(this.userId).subscribe(console.log);
    this.userNickname = "";
  }

  reload() {
    this.userIconURL = MagliveApiClient.getUserIconURL(Mag2LocalStorage.getUserId());

    MagliveApiClient.getAuthority().subscribe(authority => {
      if (authority !== "NOT_LOGIN") {
        this.authority = authority
      } else {
        this.authority = undefined
      }

      // this.player = new PlayerNative(this.video);
      this.afs.collection<Live>('lives', ref =>
        ref.where("status", "==", "ON_AIR")
          .where("options.viewerSegment", "==", "ALL")
          .limit(1)
      ).valueChanges().subscribe(lives => {
        if (authority !== "NOT_LOGIN" && 1 <= lives.length) {
          this.player.play(playbackURLOf(environment.baseURL, lives[0].broadcastId), playbackQuery(authority, "NATIVE"), true);
        }
      });

      if (authority !== "NOT_LOGIN" && authority.publishingReleasedPaymentMagazineIds.length > 0) {
        this.liveThumbnailMagazineId = authority.publishingReleasedPaymentMagazineIds[0].toString();
        this.loadLiveThumbnail(this.liveThumbnailMagazineId)
      }
    });

    this.follows = this.afs.collection<Follow>("follows", ref => ref
      .where('userId', '==', this.userId)
      .orderBy('createdAt', 'desc')
    ).valueChanges();

    MagliveApiClient.getUserProfile(this.userId).subscribe(x => {
      if (x === 'NOT_AUTHORIZED') {
        return;
      } else if (x === "NOT_FOUND") {
        this.userNickname = '';
      } else {
        this.userNickname = x.nickname
      }
    });

    if (this.liveThumbnailMagazineId) {
      this.submitLiveThumbnailMagazineId()
    }
  }

  uploadUserIcon() {
    const file = DebugPageComponent.retrieveFileFromNativeElement(this.userIconInput.nativeElement);
    if (file === null) {
      console.error("file not found.");
      return;
    }

    const data = new FormData();
    data.append("icon", file, file.name);
    this.http.post(
      environment.baseURL.magliveAPI + "api/v2/users/my/icon",
      data,
      {
        headers: {"X-Mag2-User": Mag2LocalStorage.getUserId().toString()}
      }
    ).subscribe(() => this.reload(), console.error)
  }

  removeUserIcon() {
    if (!confirm('ユーザーID' + Mag2LocalStorage.getUserId() + 'のアイコンを削除しても良いですか？')) {
      return;
    }
    this.http.delete(
      environment.baseURL.magliveAPI + "api/v2/users/my/icon",
      {
        headers: {"X-Mag2-User": Mag2LocalStorage.getUserId().toString()}
      }
    ).subscribe(() => this.reload(), console.error)
  }

  onPlayerModeSelected(selected: any) {
    Mag2LocalStorage.setPlayerMode(selected.target.value);

    this.changedPlayerMode = true;
    let x = Rx.interval(1000).subscribe(() => {
      this.changedPlayerMode = false;
      x.unsubscribe();
    });
  }

  submitLiveThumbnailMagazineId() {
    if (!this.liveThumbnailMagazineId) {
      return;
    }
    this.loadLiveThumbnail(this.liveThumbnailMagazineId)
  }

  private loadLiveThumbnail(magazineId: string) {
    MagliveApiClient.listLiveThumbnailPaths(magazineId).pipe(
      map(paths => {
        console.log(paths)
        this.liveThumbnails = paths.map(x => {
          return {
            URL: environment.baseURL.magliveAPI + `public-api/v2/magazines/${magazineId}/live-thumbnails/` + encodeURIComponent(x),
            path: x
          }
        })
      })
    ).subscribe()
  }

  private static retrieveFileFromNativeElement(el: HTMLInputElement) {
    if (el.files === null || el.files.length <= 0) {
      return null;
    }

    const file = el.files.item(0);
    if (file === null) {
      return null;
    }

    return file;
  }

  uploadLiveThumbnail() {
    const file = DebugPageComponent.retrieveFileFromNativeElement(this.liveThumbnailInput.nativeElement);
    if (file === null) {
      console.error("file not found.");
      return;
    }

    const data = new FormData();
    data.append("icon", file, file.name);
    this.http.post(
      environment.baseURL.magliveAPI + `api/v2/magazines/${this.liveThumbnailMagazineId}/live-thumbnails`,
      data,
      {
        headers: {"X-Mag2-User": Mag2LocalStorage.getUserId().toString()}
      }
    ).subscribe(() => this.reload(), console.error)
  }

  removeLiveThumbnail(path: string) {
    if (!this.liveThumbnailMagazineId) {
      return;
    }

    if (!confirm(`メルマガID: ${this.liveThumbnailMagazineId} のアイコン ${path} を削除しても良いですか？`)) {
      return;
    }

    this.http.delete(
      environment.baseURL.magliveAPI + `api/v2/magazines/${this.liveThumbnailMagazineId}/live-thumbnails/${encodeURIComponent(path)}`,
      {
        headers: {"X-Mag2-User": Mag2LocalStorage.getUserId().toString()}
      }
    ).subscribe(() => this.reload(), console.error)
  }

  submitFollowMagazineId() {
    if (!this.followMagazineId) {
      return;
    }
    this.followMagazine(this.followMagazineId)
  }

  private followMagazine(magazineId: string) {
    // TODO
    MagliveApiClient.followMagazine(magazineId, "hoge").subscribe(_ => this.reload())
  }

  unfollowMagazine(follow: Follow) {
    if (!follow.following) {
      return;
    }
    if (!confirm(`${follow.magazineId} のチャンネル登録を解除します。よろしいですか？`)) {
      return;
    }

    // TODO
    MagliveApiClient.unfollowMagazine(follow.magazineId, "hoge").subscribe(() => this.reload(), console.error)
  }

  ngOnDestroy(): void {
    this.player.destroy();
  }
}

